export const GET_CREATORS = 'containers/CreatorsPage/GET_CREATORS';
export const GET_CREATORS_SUCCESS = 'containers/CreatorsPage/GET_CREATORS_SUCCESS';
export const GET_CREATORS_ERROR = 'containers/CreatorsPage/GET_CREATORS_ERROR';
export const CHANGE_PAGE = 'containers/CreatorsPage/CHANGE_PAGE';
export const FILTER_PER_PAGE = 'containers/CreatorsPage/FILTER_PER_PAGE';
